module.exports = __webpack_public_path__ + "img/8_financial-wellness.8b25a289.png";